module.exports = __webpack_public_path__ + "img/3.0e058a56.png";